import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Company',
    title_bank: 'Company Bank',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'Company',
        href: '/adm/conf/company-info',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_company',
    sortDesc: true,
    fields: [
      {
        key: 'code_company',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'name',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'address',
        label: 'Alamat',
        sortable: true,
      },
      {
        key: 'city',
        label: 'Kota',
        sortable: true,
      },
      {
        key: 'phone',
        label: 'Phone',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_bank: [
      {
        key: 'code_bank',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'bank_name',
        label: 'Nama Bank',
        sortable: true,
      },
      {
        key: 'bank_account',
        label: 'No Rekening',
        sortable: true,
      },
      {
        key: 'bank_owner',
        label: 'Atas Nama',
        sortable: true,
      },
      {
        key: 'bank_location',
        label: 'Cabang',
        sortable: true,
      },
      {
        key: 'bank_type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'acc_name',
        label: 'Akun',
        sortable: true,
      },
      {
        key: 'bank_status',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      name: '',
      address: '',
      city: '',
      province: '',
      postal_code: '',
      country: '',
      phone: '',
      fax: '',
      email: '',
    },
    form_bank: {
      bank_name: '',
      bank_account: '',
      bank_owner: '',
      bank_location: '',
      bank_status: '',
    },
    list_bank: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_bank(state) {
    return state.data.form_bank;
  },
};

export const mutations = {
  changeCompany(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchCompany(context, params = null) {
    let result = await ApiGetRequest(`conf/company`, params);
    return !result.error ? result.data.object : [];
  },

  async getListAllBankAccount({ commit }, payload = null) {
    commit('changeCompany', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/bank-account`, payload);
    commit('changeCompany', {
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getListBankAccount({ commit, state }) {
    commit('changeCompany', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_company: data.id_company,
    };

    let result = await ApiGetRequest(`opr/bank-account`, params);
    commit('changeCompany', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListCompany({ commit, state }) {
    commit('changeCompany', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`conf/company`, params);
    commit('changeCompany', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailCompany({ commit, state }, payload = null) {
    commit('changeCompany', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`conf/company/${payload.id}`);
    commit('changeCompany', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async getDetailBank({ commit, state }, payload = null) {
    commit('changeCompany', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/bank-account/${payload.id}`);
    commit('changeCompany', {
      loading: false,
      form_bank: {
        ...data.form_bank,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createBankAccount({ commit, state, dispatch }) {
    commit('changeCompany', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/bank-account`, state.data.form_bank);
    commit('changeCompany', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateBankAccount({ commit, state, dispatch }, payload = null) {
    commit('changeCompany', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/bank-account/${payload.id}`,
      state.data.form_bank
    );

    commit('changeCompany', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteBankAccount({ commit, dispatch }, payload = null) {
    commit('changeCompany', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/bank-account/${payload.id}`);
    commit('changeCompany', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async uploadImage({ commit, state }, payload) {
    commit('changeCompany', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeCompany', {
      loading: false,
    });

    if (!result.error) {
      commit('changeCompany', {
        form: {
          ...data.form,
          stempel: result?.data?.object?.path,
        },
      });
    }
  },

  async createCompany({ commit, state, dispatch }) {
    commit('changeCompany', {
      loading: true,
    });

    let result = await ApiPostRequest(`conf/company`, state.data.form);
    commit('changeCompany', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCompany({ commit, state, dispatch }, payload = null) {
    commit('changeCompany', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `conf/company/${payload.id}`,
      state.data.form
    );

    commit('changeCompany', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCompany({ commit, dispatch }, payload = null) {
    commit('changeCompany', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`conf/company/${payload.id}`);
    commit('changeCompany', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
